import type { InstanceAuthenticationConfiguration } from 'src/models/authentication';

type AuthenticationRedirectContext = {
	authRequired: boolean;
	routeName: null | string | symbol | undefined;
	selectedInstanceAuthentication: InstanceAuthenticationConfiguration | null | undefined;
};

export const resolveAuthenticationRedirect = ({
	authRequired,
	routeName,
	selectedInstanceAuthentication,
}: AuthenticationRedirectContext): null | string => {
	const hasActiveAuthentication =
		selectedInstanceAuthentication !== null && selectedInstanceAuthentication !== undefined;

	if (authRequired && !hasActiveAuthentication && routeName !== 'login') {
		return '/login';
	}

	if (!authRequired && routeName === 'login' && hasActiveAuthentication) {
		return '/';
	}

	return null;
};
